var _g, _g2, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 163 162",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2526_16480)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 80.7735,
    cy: 81.7735,
    r: 70.7735,
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_2526_16480)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 81.335,
    cy: 81.2117,
    r: 49.9908,
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1286 77.5091C11.2012 59.7396 18.9309 43.027 31.7769 30.7028C44.6228 18.3785 61.6414 11.348 79.4401 11.0126C97.2388 10.6772 114.51 17.0616 127.811 28.8931C141.112 40.7247 149.466 57.1342 151.208 74.8507L144.568 75.5033C142.991 59.4569 135.425 44.5941 123.377 33.8779C111.33 23.1617 95.6867 17.3791 79.5658 17.6829C63.4449 17.9867 48.0306 24.3545 36.3956 35.517C24.7606 46.6795 17.7595 61.8167 16.788 77.9111L10.1286 77.5091Z",
    fill: "#2C357D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.16 78.02C43.24 76.78 43.7133 75.8133 44.58 75.12C45.46 74.4267 46.58 74.08 47.94 74.08C48.8733 74.08 49.68 74.2467 50.36 74.58C51.04 74.9133 51.5533 75.3667 51.9 75.94C52.2467 76.5133 52.42 77.16 52.42 77.88C52.42 78.7067 52.2 79.4133 51.76 80C51.32 80.5867 50.7933 80.98 50.18 81.18V81.26C50.9667 81.5 51.58 81.94 52.02 82.58C52.46 83.2067 52.68 84.0133 52.68 85C52.68 85.7867 52.5 86.4867 52.14 87.1C51.78 87.7133 51.2467 88.2 50.54 88.56C49.8333 88.9067 48.9867 89.08 48 89.08C46.56 89.08 45.3733 88.7133 44.44 87.98C43.52 87.2333 43.0267 86.1667 42.96 84.78H45.16C45.2133 85.4867 45.4867 86.0667 45.98 86.52C46.4733 86.96 47.14 87.18 47.98 87.18C48.7933 87.18 49.42 86.96 49.86 86.52C50.3 86.0667 50.52 85.4867 50.52 84.78C50.52 83.8467 50.22 83.1867 49.62 82.8C49.0333 82.4 48.1267 82.2 46.9 82.2H46.38V80.32H46.92C48 80.3067 48.82 80.1267 49.38 79.78C49.9533 79.4333 50.24 78.8867 50.24 78.14C50.24 77.5 50.0333 76.9933 49.62 76.62C49.2067 76.2333 48.62 76.04 47.86 76.04C47.1133 76.04 46.5333 76.2333 46.12 76.62C45.7067 76.9933 45.46 77.46 45.38 78.02H43.16ZM56.295 89.14C55.8817 89.14 55.535 89 55.255 88.72C54.975 88.44 54.835 88.0933 54.835 87.68C54.835 87.2667 54.975 86.92 55.255 86.64C55.535 86.36 55.8817 86.22 56.295 86.22C56.695 86.22 57.035 86.36 57.315 86.64C57.595 86.92 57.735 87.2667 57.735 87.68C57.735 88.0933 57.595 88.44 57.315 88.72C57.035 89 56.695 89.14 56.295 89.14ZM59.6192 85.96V84.24L66.3392 74.6H69.0992V83.98H70.9592V85.96H69.0992V89H66.8592V85.96H59.6192ZM66.9592 76.92L62.2392 83.98H66.9592V76.92ZM82.2484 76.38H75.5484V80.36C75.8284 79.9867 76.2418 79.6733 76.7884 79.42C77.3484 79.1667 77.9418 79.04 78.5684 79.04C79.6884 79.04 80.5951 79.28 81.2884 79.76C81.9951 80.24 82.4951 80.8467 82.7884 81.58C83.0951 82.3133 83.2484 83.0867 83.2484 83.9C83.2484 84.8867 83.0551 85.7667 82.6684 86.54C82.2951 87.3 81.7284 87.9 80.9684 88.34C80.2218 88.78 79.3018 89 78.2084 89C76.7551 89 75.5884 88.64 74.7084 87.92C73.8284 87.2 73.3018 86.2467 73.1284 85.06H75.3484C75.4951 85.6867 75.8218 86.1867 76.3284 86.56C76.8351 86.92 77.4684 87.1 78.2284 87.1C79.1751 87.1 79.8818 86.8133 80.3484 86.24C80.8284 85.6667 81.0684 84.9067 81.0684 83.96C81.0684 83 80.8284 82.2667 80.3484 81.76C79.8684 81.24 79.1618 80.98 78.2284 80.98C77.5751 80.98 77.0218 81.1467 76.5684 81.48C76.1284 81.8 75.8084 82.24 75.6084 82.8H73.4484V74.38H82.2484V76.38ZM102.217 75.1V89H99.9372V82.92H93.3972V89H91.1172V75.1H93.3972V81.06H99.9372V75.1H102.217ZM107.499 79.58C107.832 79.02 108.272 78.5867 108.819 78.28C109.379 77.96 110.039 77.8 110.799 77.8V80.16H110.219C109.325 80.16 108.645 80.3867 108.179 80.84C107.725 81.2933 107.499 82.08 107.499 83.2V89H105.219V77.98H107.499V79.58ZM116.895 89.18C116.028 89.18 115.248 89.0267 114.555 88.72C113.875 88.4 113.335 87.9733 112.935 87.44C112.535 86.8933 112.321 86.2867 112.295 85.62H114.655C114.695 86.0867 114.915 86.48 115.315 86.8C115.728 87.1067 116.241 87.26 116.855 87.26C117.495 87.26 117.988 87.14 118.335 86.9C118.695 86.6467 118.875 86.3267 118.875 85.94C118.875 85.5267 118.675 85.22 118.275 85.02C117.888 84.82 117.268 84.6 116.415 84.36C115.588 84.1333 114.915 83.9133 114.395 83.7C113.875 83.4867 113.421 83.16 113.035 82.72C112.661 82.28 112.475 81.7 112.475 80.98C112.475 80.3933 112.648 79.86 112.995 79.38C113.341 78.8867 113.835 78.5 114.475 78.22C115.128 77.94 115.875 77.8 116.715 77.8C117.968 77.8 118.975 78.12 119.735 78.76C120.508 79.3867 120.921 80.2467 120.975 81.34H118.695C118.655 80.8467 118.455 80.4533 118.095 80.16C117.735 79.8667 117.248 79.72 116.635 79.72C116.035 79.72 115.575 79.8333 115.255 80.06C114.935 80.2867 114.775 80.5867 114.775 80.96C114.775 81.2533 114.881 81.5 115.095 81.7C115.308 81.9 115.568 82.06 115.875 82.18C116.181 82.2867 116.635 82.4267 117.235 82.6C118.035 82.8133 118.688 83.0333 119.195 83.26C119.715 83.4733 120.161 83.7933 120.535 84.22C120.908 84.6467 121.101 85.2133 121.115 85.92C121.115 86.5467 120.941 87.1067 120.595 87.6C120.248 88.0933 119.755 88.48 119.115 88.76C118.488 89.04 117.748 89.18 116.895 89.18Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2526_16480",
    x: 4.6,
    y: 5.6,
    width: 152.347,
    height: 152.347,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 3,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_2526_16480"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.4 0 0 0 0 0.4 0 0 0 0 0.4 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2526_16480"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2526_16480",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_2526_16480",
    x: 0.644238,
    y: 0.520947,
    width: 161.381,
    height: 161.382,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_2526_16480"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 13.35
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.4 0 0 0 0 0.4 0 0 0 0 0.4 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2526_16480"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2526_16480",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimer);
export default __webpack_public_path__ + "static/media/timer.f3297dfc6d338659fe8b98b532e03f86.svg";
export { ForwardRef as ReactComponent };